import { Table } from "@mantine/core";
import { formatNumberAsString, safeUnits } from "common/utils";
import React from "react";
import { RptSalesAnalysisByMonths } from "types/model.types";

interface ISalesAnalysisViewProps {
  data: RptSalesAnalysisByMonths | null;
}
const SalesAnalysisView: React.FC<ISalesAnalysisViewProps> = ({ data }) => {
  return (
    <>
      {!data || data.length === 0 ? (
        <Table.Tr>
          <Table.Td colSpan={18}>
            No data available for the selected criteria.
          </Table.Td>
        </Table.Tr>
      ) : (
        data.map((row, index) => {
          const units = safeUnits(row.unitsCtn);
          return (
            <Table.Tr key={`${index}-${row.id}`}>
              <Table.Td>{row.id}</Table.Td>
              <Table.Td>{row.description}</Table.Td>
              <Table.Td>{formatNumberAsString(row.lastSale / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.jan / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.feb / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.mar / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.apr / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.may / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.jun / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.jul / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.aug / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.sep / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.oct / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.nov / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.dec / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.cord / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.sord / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.onHand / units)}</Table.Td>
              <Table.Td>{row.onHand <= 0 ? " <<< " : ""}</Table.Td>
            </Table.Tr>
          );
        })
      )}
    </>
  );
};

export default SalesAnalysisView;
